import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import { useQuery } from 'react-query';
import type { RootState } from 'mainStore';
import './_coisErrors.scss';
import { encrypt } from 'shared-components/hooks/useEncryption';
import type { Ipayload } from './types';

export default function ButtonAppBar(): JSX.Element {
  const currentBuilding = useSelector(
    (state: RootState) => state.workspaces.currentBuilding,
  );
  const navigate = useNavigate();
  const { data: coisErrorCount } = useQuery(
    'get/cois-errors',
    async () => axios({
      url: `/api/coise-errors-v2/?property=${currentBuilding.id}`,
      method: 'get',
    }),
    {
      enabled: Boolean(currentBuilding.id),
      select: (res: AxiosResponse<Ipayload>) => res.data.total_count,
    },
  );

  return (

    <div>
      { coisErrorCount !== undefined && coisErrorCount > 0 && (
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position='static' className='cois-error-bar' elevation={1}>
            <Toolbar>

              <i className='fa-solid fa-circle-exclamation icon' />

              <Typography variant='h6' component='div' sx={{ flexGrow: 1 }}>

                <div className='details'>
                  {coisErrorCount}
                  {' '}
                  deficient certification
                </div>

              </Typography>
              <Typography
                className='learn-more'
                onClick={(): void => {
                  navigate(`/building/cois/errors/${encrypt(currentBuilding.id)}`);
                }}
              >

                Learn More

              </Typography>
            </Toolbar>
          </AppBar>
        </Box>
      )}
    </div>
  );
}
